import React from 'react';
import PropTypes from 'prop-types';

import {Loading} from 'Common/Structure';

import SquareForm from '.';
import CardOnFile from '../CardOnFile';

const SquareFormWrapper = props => {
  return props.cardOnFile ? (
    <div>
      {props.cardOnFile.length > 0 && (
        <CardOnFile
          cardsOnFile={props.cardOnFile.map(x => ({
            ...x,
            lastFourDigits: x.last4,
            externalCustomerId: `${x.squareProfileId}`,
          }))}
          onChangeCardSelection={(e, {value}) =>
            props.onChangeCardSelection(value)
          }
          processorName="Square"
          selectedCard={(props.data && props.data.selectedCardId) || '0'}
        />
      )}

      {props.showCreditCard && (
        <SquareForm
          applicationId={props.applicationId}
          locationId={props.locationId}
          nonce={props.data && props.data.nonce}
          setNonce={nonce => props.setProcessor({nonce})}
          updateSubmitButtonEnabled={props.updateSubmitButtonEnabled}
        />
      )}
    </div>
  ) : (
    <Loading />
  );
};

SquareFormWrapper.defaultProps = {
  cardOnFile: null,
  data: {},
};

SquareFormWrapper.propTypes = {
  applicationId: PropTypes.string.isRequired,
  cardOnFile: PropTypes.arrayOf(
    PropTypes.shape({
      cardType: PropTypes.string.isRequired,
      squareProfileId: PropTypes.number.isRequired,
      last4: PropTypes.string.isRequired,
    }),
  ),
  showCreditCard: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    nonce: PropTypes.string,
    selectedCardId: PropTypes.string,
  }),

  // functions
  onChangeCardSelection: PropTypes.func.isRequired,
  setProcessor: PropTypes.func.isRequired,
  updateSubmitButtonEnabled: PropTypes.func.isRequired,
};

export default SquareFormWrapper;



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentCollection/components/PaymentForm/SquareForm/Wrapper.js